import {
  Atom,
  BarChart3,
  Book,
  BookOpen,
  Calculator,
  Dna,
  Microscope,
  TestTube,
  TrendingUp,
  Wallet
} from 'lucide-react';

export const DEFAULT = {
  PHOTO_URL:
    'https://firebasestorage.googleapis.com/v0/b/cetrainer-95f5e.appspot.com/o/ProfilePictures%2FxQwPXksQwzOfKq87C9MD03jldoG3%2Fprofilepicture.png?alt=media&token=05f5ea9b-d701-4aa0-aca4-d65a103f4bd4',
  DISPLAY_NAME: 'Unnamed'
};

export const RULES = {
  EMAIL: {
    required: true,
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Dit veld moet een geldig e-mailadres bevatten'
    }
  },
  PASSWORD: {
    required: true,
    minLength: {
      value: 6,
      message: '6'
    },
    maxLength: {
      value: 20,
      message: '20'
    }
  }
};

export const subjectsDictionary = {
  VWO: [
    'Wiskunde A',
    'Wiskunde B',
    'Wiskunde C',
    'Natuurkunde',
    'Scheikunde',
    'Geschiedenis',
    'Engels'
  ],
  HAVO: [
    'Wiskunde A',
    'Wiskunde B',
    'Natuurkunde',
    'Scheikunde',
    'Geschiedenis',
    'Engels'
  ],
  'VMBO-TL-GL': [
    'Wiskunde',
    'Biologie',
    'Economie',
    'Nask 1',
    'Nask 2',
    'Geschiedenis',
    'Engels'
  ],
  'VMBO-KB': [
    'Wiskunde',
    'Nask 1',
    'Economie',
    'Biologie',
    'Geschiedenis',
    'Engels'
  ],
  'VMBO-BB': [
    'Wiskunde',
    'Nask 1',
    'Economie',
    'Biologie',
    'Geschiedenis',
    'Engels'
  ]
};

export const EnrollmentSteps = [
  { label: 'Welkom' },
  { label: 'Gegevens' },
  { label: 'Intro' },
  { label: 'App Tour' },
  { label: 'Starten' }
];

export const MODAL_ATTRIBUTES = {
  dismissableMask: true,
  modal: true,
  draggable: false,
  blockScroll: true
};

/** Facet player: bookmark tool and strip dot (spec O1). */
export const FACET_BOOKMARK_ENABLED = true;

/**
 * Facet player: a source longer than this many characters of HTML gets the
 * draggable divider between source and question (P0-7). The split is
 * remembered per browser under FACET_SOURCE_SPLIT_KEY (hooks/useSourceSplit).
 */
export const FACET_SOURCE_SPLIT_MIN_CHARS = 1500;
export const FACET_SOURCE_SPLIT_KEY = 'facetSourceSplit';

/** The CMS section editor's one form (Cmd/Ctrl+S and the Name field find it). */
export const SECTION_FORM_ID = 'edit-section-form';

export const QUOTES = [
  'Een goede leraar moet zowel inspireren als irriteren',
  'Haal even diep adem en lach',
  'Natuurlijk praat ik tegen mezelf. Soms heb ik advies van een expert nodig',
  'Als je in het dal blijft zie je nooit de andere kant van de berg',
  'Wacht niet op een goede dag, maak er één',
  'Moeilijk betekent niet onmogelijk. Het betekent dat je hard moet werken',
  'Oordeel niet over anderen als je hun last nooit gedragen hebt',
  'Met beide voeten op de grond kom je geen stap vooruit',
  'Als je goed kijkt kijkt, kun je iedere dag iets moois zien',
  'Niets was mogelijk, todat iemand het deed..',
  'Ik heb geen inspirerende quote nodig, geef mij maar koffie',
  'De stilte der natuur heeft veel geluiden',
  'Het leven is net als fietsen, om balans te houden moet je door fietsen. ',
  'Streef naar vooruitgang en niet perfectie',
  'Iedere expert is ooit een beginner geweest',
  'Educatie is de sterkste wapen om de wereld positief te veranderen',
  'Iedere student kan leren, alleen niet op dezelfde dag of dezelfde manier',
  'Als een plan niet werkt, verander dan je plan maar nooit je doel.',
  'Het mooie aan leren is dat het iets is dat niemand je kan ontnemen',
  'Het leven van een kind is net als een stuk papier waarop iedereen een afdruk achterlaat',
  'Alles wat je hoort vergeet je, alles wat je ziet onthoud je en alles wat je doet begrijp je!',
  'Je wordt nooit echt volwasssen, je leert alleen hoe je je volwassen dient te gedragen',
  'Er is geen lift naar succes, pak de trap',
  'Als je nooit een fout gemaakt hebt dan heb je nooit iets nieuws geprobeerd',
  'Als mensen nooit stomme zaken uitgeprobeerd hebben dan zou er nooit iets intelligents zijn ontstaan',
  'Alles wat we leren met plezier vergeten we nooit',
  'CETrainer is in het leven geroepen om je leven nog zuurder te maken',
  'Wat kwam er nou eigenlijk eerder? De kip of het ei?',
  'Geef iemand een vis en je hebt diegene gevoerd voor een dag, leer een persoon om te vissen en je voedt deze persoon voor het hele leven ',
  'Zou een rups ooit weten dat hij ooit een vlinder zou worden?',
  'In leraar zit niet voor niets het woord raar',
  'Docenten noemen het spieken, wij noemen het teamwork',
  'Doet mijn laptop het eindelijk, crashen mijn hersens',
  'Spring altijd in het diepe. Het ondiepe doet namelijk zeer',
  'Wat heeft de school eigenlijk van mij geleerd?',
  'Je moet de waarheid niet verwarren met de mening van de meerderheid',
  'Wees jezelf, er zijn al zoveel anderen',
  'Nooit te oud om te leren waarom dan zo vroeg beginnen?',
  'De scholen zijn weer begonnen nou jij nog',
  'Soms krijg ik meer errors dan mijn rekenmachine',
  'Het examen doet me soms denken aan het kapsel van mijn buurvrouw. Kort en pittig',
  'Mijn gemiddelde is met de valversnelling van de zon naar beneden gedonderd'
];

export const LEVELS = ['HAVO', 'VWO', 'VMBO-TL-GL', 'VMBO-KB', 'VMBO-BB'];

export const SUBJECT_ICONS = {
  Atom,
  Calculator,
  BarChart3,
  TrendingUp,
  Wallet,
  Dna,
  Book,
  BookOpen,
  Microscope,
  TestTube
};

export const SUBJECTS: any = {
  Natuurkunde: {
    icon: 'Atom',
    tips: {
      HAVO: 'https://player.vimeo.com/video/918670421',
      VWO: 'https://player.vimeo.com/video/918670439'
    }
  },
  Scheikunde: {
    icon: 'TestTube',
    tips: {
      HAVO: 'https://player.vimeo.com/video/919934688',
      VWO: 'https://player.vimeo.com/video/919934607'
    }
  },
  'Wiskunde A': {
    icon: 'BarChart3',
    tips: {
      HAVO: 'https://player.vimeo.com/video/825049001',
      VWO: 'https://player.vimeo.com/video/1161222597'
    }
  },
  'Wiskunde B': {
    icon: 'TrendingUp',
    tips: {
      HAVO: 'https://player.vimeo.com/video/825054725',
      VWO: 'https://player.vimeo.com/video/825054743'
    }
  },
  'Wiskunde C': {
    icon: 'BarChart3'
  },
  Wiskunde: {
    icon: 'Calculator',
    tips: {
      'VMBO-TL-GL': 'https://player.vimeo.com/video/918670289',
      'VMBO-KB': 'https://player.vimeo.com/video/918670269',
      'VMBO-BB': 'https://player.vimeo.com/video/918670239'
    }
  },
  Economie: {
    icon: 'Wallet'
  },
  Biologie: {
    icon: 'Dna'
  },
  Nederlands: {
    icon: 'Book'
  },
  Engels: {
    icon: 'BookOpen',
    tips: {
      'VMBO-TL-GL': 'https://player.vimeo.com/video/1067362223',
      'VMBO-KB': 'https://player.vimeo.com/video/1067362223',
      'VMBO-BB': 'https://player.vimeo.com/video/1067362223'
    }
  },
  'Nask 1': {
    icon: 'Microscope',
    tips: {
      'VMBO-TL-GL': 'https://player.vimeo.com/video/918670192',
      'VMBO-KB': 'https://player.vimeo.com/video/918670228',
      'VMBO-BB': 'https://player.vimeo.com/video/918670215'
    }
  },
  'Nask 2': {
    icon: 'Atom',
    tips: {
      'VMBO-TL-GL': 'https://player.vimeo.com/video/919934661'
    }
  },
  Geschiedenis: {
    icon: 'Book'
  }
};

export const STATISTICS_DATA = [
  {
    icon: 'ion:school',
    title: 'Aantal leerlingen',
    value: 5800
  },
  {
    icon: 'bxs:school',
    title: 'Aantal scholen',
    value: 54
  },
  {
    icon: 'tabler:star-filled',
    title: 'Beoordeling',
    value: '4.0'
  }
];

export const subjectsByLevel = {
  HAVO: [
    'Natuurkunde',
    'Scheikunde',
    'Wiskunde A',
    'Wiskunde B',
    'Biologie',
    'Geschiedenis'
  ],
  VWO: [
    'Natuurkunde',
    'Scheikunde',
    'Wiskunde A',
    'Wiskunde B',
    'Wiskunde C',
    'Biologie',
    'Geschiedenis'
  ],
  'VMBO-TL-GL': [
    'Wiskunde',
    'Engels',
    'Nederlands',
    'Nask 1',
    'Nask 2',
    'Biologie',
    'Economie',
    'Geschiedenis'
  ],
  'VMBO-KB': [
    'Wiskunde',
    'Engels',
    'Nederlands',
    'Nask 1',
    'Biologie',
    'Economie',
    'Geschiedenis'
  ],
  'VMBO-BB': [
    'Wiskunde',
    'Engels',
    'Nederlands',
    'Nask 1',
    'Biologie',
    'Economie',
    'Geschiedenis'
  ]
};

// Subjects (Firestore subject ids, as in the exam URL) whose exam view hides
// the drawing tool (Tekenen) on bijlagen.
export const DRAWING_TOOL_DISABLED_SUBJECTS = [
  'Geschiedenis',
  'Aardrijkskunde'
];

interface Level {
  name: string;
  code: string;
}

export const levels: Level[] = [
  {
    name: 'HAVO',
    code: 'HAVO'
  },
  {
    name: 'VWO',
    code: 'VWO'
  },
  {
    name: 'VMBO TL/GL',
    code: 'VMBO-TL-GL'
  },
  {
    name: 'VMBO KB',
    code: 'VMBO-KB'
  },
  {
    name: 'VMBO BB',
    code: 'VMBO-BB'
  }
];

export const HeaderLinks = [
  {
    title: 'Home',
    link: '/'
  },
  {
    title: 'Over ons',
    link: '/Overons'
  },
  {
    title: 'FAQ',
    link: '/faq'
  },
  {
    title: 'Contact',
    link: '/contact'
  }
];

export interface SectionItem {
  image: string;
  heading: string;
  description1: string;
  description2: string;
  subtitle?: string; // Optional for the second item
}

// ── Feedback flow ───────────────────────────────────────────────

/**
 * Audience of a feedback submission. Students and teachers share the
 * same `feedback` Firestore collection but get a distinct per-year flag
 * on their user doc so the popup / sidebar banner / email campaign can
 * be gated per audience without crosstalk.
 */
export const FEEDBACK_AUDIENCES = {
  STUDENT: 'student',
  TEACHER: 'teacher'
} as const;

export type FeedbackAudience =
  (typeof FEEDBACK_AUDIENCES)[keyof typeof FEEDBACK_AUDIENCES];

/**
 * Field name on the user doc that gates the per-year feedback prompt.
 * The legacy field `feedbackGiven` (no year) stays read-only.
 *
 * For backwards compatibility the student flag keeps its original
 * `feedbackGiven_<year>` shape; the teacher flag uses a distinct
 * `teacherFeedbackGiven_<year>` namespace.
 */
export const FEEDBACK_FLAG_KEY = (
  year: number,
  audience: FeedbackAudience = FEEDBACK_AUDIENCES.STUDENT
): string =>
  audience === FEEDBACK_AUDIENCES.TEACHER
    ? `teacherFeedbackGiven_${year}`
    : `feedbackGiven_${year}`;

/**
 * Funnel events emitted by the feedback flow. See
 * docs/feedback-schema.md for the full meaning of each event.
 */
export const FEEDBACK_TELEMETRY_EVENTS = {
  POPUP_SHOWN: 'POPUP_SHOWN',
  POPUP_DISMISSED: 'POPUP_DISMISSED',
  POPUP_CLICKED: 'POPUP_CLICKED',
  FORM_OPENED: 'FORM_OPENED',
  QUESTION_ANSWERED: 'QUESTION_ANSWERED',
  FORM_ABANDONED: 'FORM_ABANDONED',
  FORM_SUBMITTED: 'FORM_SUBMITTED',
  NOTIFICATION_SHOWN: 'NOTIFICATION_SHOWN',
  NOTIFICATION_CLICKED: 'NOTIFICATION_CLICKED',
  BANNER_SHOWN: 'BANNER_SHOWN',
  BANNER_CLICKED: 'BANNER_CLICKED',
  BANNER_DISMISSED: 'BANNER_DISMISSED',
  POST_ATTEMPT_SHOWN: 'POST_ATTEMPT_SHOWN',
  POST_ATTEMPT_CLICKED: 'POST_ATTEMPT_CLICKED'
} as const;

export type FeedbackTelemetryEvent =
  (typeof FEEDBACK_TELEMETRY_EVENTS)[keyof typeof FEEDBACK_TELEMETRY_EVENTS];

/**
 * How a user reached the feedback form. Persisted on the submission
 * doc (`feedback/{id}.source`) and on every telemetry event.
 */
export const FEEDBACK_TRIGGER_SOURCES = {
  POPUP: 'POPUP',
  NOTIFICATION: 'NOTIFICATION',
  DIRECT_NAV: 'DIRECT_NAV',
  POST_ATTEMPT: 'POST_ATTEMPT',
  EMAIL_CAMPAIGN: 'EMAIL_CAMPAIGN',
  BANNER: 'BANNER'
} as const;

export type FeedbackTriggerSource =
  (typeof FEEDBACK_TRIGGER_SOURCES)[keyof typeof FEEDBACK_TRIGGER_SOURCES];

export const sectionData: SectionItem[] = [
  {
    image: require('/assets/news/news1.png'),
    subtitle: 'Bron: Het Parool',
    heading: 'Kansen(on)gelijkheid',
    description1:
      "Op de middelbare school zijn er activiteiten die niet voor iedereen weggelegd is. Zonder er bij stil te staan kennen wij het allemaal wel. Denk aan leerlingen die schoolfoto's überhaupt niet aannemen of leerlingen diehelaas niet mee kunnen op een buitenlandse excursie. Maar er is meer. Experts vrezen voor toename van ongelijkheid.",
    description2:
      'Mede door de populariteit van peperdure examentrainingen. Zo is het momenteel gebruikelijk dat leerlingen na hun schoolexamen een externe training volgen. Hier zit een drempel voor een grote groep leerlingen wiens ouders de kosten niet kunnen ophoesten. Alle leerlingen verdienen dezelfde kans om zich goed voor te bereiden op het eindexamen.'
  },
  {
    image: require('assets/Afbeelding1.jpg'),
    heading: 'CET voor iedereen',
    description1:
      'CETrainer is een platform die gratis moet zijn voor alle leerlingen. Wij hanteren een kostprijs waar schoolbesturen niet omheen kunnen. Hiermee worden de kosten voor onze examentraining nooit doorgerekend aan de ouders van de scholieren. De vraag naar examentrainingen is enorm gestegen, helemaal sinds de Corona pandemie. ',
    description2:
      'Steeds meer leerlingen kijken graag online instructies en steeds meer docenten maken gebruik van videomateriaal in de lessen ter instructie. Daarnaast behoort het gebruik van online leermiddelen steeds meer tot het basispakket van leerlingen. De krantenkoppen spreken boekdelen.'
  }
];

// Layouts the CMS exam section editor can switch between, remembered per
// browser under SECTION_EDITOR_LAYOUT_KEY (hooks/useSectionEditorLayout.ts).
export const SECTION_EDITOR_LAYOUTS = [
  'section',
  'focus',
  'split',
  'tabs'
] as const;

export type SectionEditorLayout = (typeof SECTION_EDITOR_LAYOUTS)[number];

export const SECTION_EDITOR_LAYOUT_KEY = 'cmsSectionEditorLayout';

// Narrowest window the split layout fits in. Mirrors the SASS $xl-up
// breakpoint (stylesheets/abstracts/_variables.sass: $xl: 1200px); change both
// together.
export const SECTION_EDITOR_SPLIT_MIN_WIDTH = 1200;

// With the PDF panel open, Split puts question and answers side by side only
// while the sections tab's main column (content box) is at least this wide.
// Today's narrowest Split - a 1200px window, the 248px app sidebar, the 56px
// rail - leaves that column about 839px; a little slack keeps the same floor.
export const SECTION_EDITOR_SPLIT_MIN_EDITOR_WIDTH = 820;

// With the PDF panel open, the exam editor's Jump to rail starts collapsed
// unless the Sections tab is at least this wide: the 260px rail, the 24px
// gutter and SECTION_EDITOR_SPLIT_MIN_EDITOR_WIDTH for the editor.
export const EXAM_EDITOR_RAIL_ROOM_WIDTH = 260 + 24 + 820;

// The exam editor's PDF panel (components/CMS/Exam/Editor/PdfPanel) docks
// beside the editor from the SASS $laptop-up breakpoint ($laptop: 1023px).
export const EXAM_PDF_PANEL_DOCK_QUERY = '(min-width: 1023px)';

// The docked PDF panel's width, as a share of the editor workspace, chosen
// with the drag handle and remembered per browser under
// EXAM_PDF_PANEL_RATIO_KEY (hooks/useExamPdfPanelWidth.ts). It never goes
// below the minimum width, nor above the maximum share or what would leave
// the editor column less than EXAM_EDITOR_MIN_WIDTH.
export const EXAM_PDF_PANEL_RATIO_KEY = 'cmsPdfPanelRatio';
export const EXAM_PDF_PANEL_DEFAULT_RATIO = 0.4;
export const EXAM_PDF_PANEL_MAX_RATIO = 0.6;
export const EXAM_PDF_PANEL_MIN_WIDTH = 420;
export const EXAM_EDITOR_MIN_WIDTH = 640;
// The handle's column between editor and panel: ExamEditor's --pdf-gap.
export const EXAM_PDF_PANEL_GAP = 20;

// Id of the element that holds the PDF panel; toggles point at it.
export const EXAM_PDF_PANEL_ID = 'exam-pdf-panel';

// Per-exam panel state in localStorage:
// `cmsPdfPanel:{level}:{subject}:{examId}` -> { open, tab, pages }.
export const EXAM_PDF_PANEL_KEY_PREFIX = 'cmsPdfPanel';

// CMS comments (docs/features/cms-comments.md): staff comments on an exam or
// one of its questions, in the top-level `cmsComments` collection.
export const CMS_COMMENTS_COLLECTION = 'cmsComments';

// Longest comment body, counted after trimming.
export const CMS_COMMENT_MAX_LENGTH = 2000;

// E2E comments start with this prefix. Only these, written by an account in
// CMS_COMMENT_TEST_AUTHORS, get `testData: true` and may be cleaned up by
// scripts/cleanup-cms-comments-test-data.ts.
export const CMS_COMMENT_TEST_PREFIX = '[TEST]';

// The QA trainer account the CMS comments E2E spec signs in as.
export const CMS_COMMENT_TEST_AUTHORS = ['demo-trainer@cetrainer.nl'] as const;

// DOM id of the comments drawer (one per page); the Comments button points
// at it with aria-controls.
export const CMS_COMMENTS_DRAWER_ID = 'cms-comments-drawer';

// React Query key of the dashboard's open-comment counts per exam.
export const CMS_COMMENT_OPEN_COUNTS_KEY = ['cms-comment-open-counts'] as const;

// Copy to CMS with images (docs/features/exam-auto-images-4a.md, D4): fill
// section-text (tekstboekje) images from the image library. On since the
// validator's assets-0.6.0 section fill and `section_key` (2026-10-06).
// Hooks pass it to the planner; false restores the 4a "add by hand" path.
export const SECTION_TEXT_AUTO_FILL_ENABLED = true;

// Exam review (docs/features/exam-auto-images-4b.md §5.3): review writes need
// examAssets.extractorVersion === extraction.assets.extractor_version, both at
// least this version (the library check).
export const REVIEW_MIN_EXTRACTOR_VERSION = 'assets-0.6.0';

// How often a failed `usedIn` write on an examAssets item is retried after
// the CMS write succeeded (backoff 500 ms, then 1500 ms).
export const COPY_USED_IN_RETRIES = 2;
